'use client';

import { useCookieConsent } from '@/hooks/use-cookie-consent';
import { Button } from '@/components/ui/button';

export function CookieConsent() {
	const { consent, updateConsent, isMounted } = useCookieConsent();

	// Do not render anything until mounted on client to prevent hydration errors
	if (!isMounted) return null;

	// Do not show if consent is already given or denied
	if (consent !== null) return null;

	return (
		<div className="fixed bottom-0 inset-x-0 z-50 border-t bg-white p-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] md:p-6 text-blue">
			<div className="container mx-auto flex flex-col items-center justify-between gap-4 md:flex-row">
				<div className="flex-1 text-sm md:text-base pr-4">
					<p className="font-semibold mb-1 text-lg">Uw ervaring verbeteren</p>
					<p>
						We gebruiken cookies zodat we u beter kunnen helpen met passend advies en een
						soepele website-ervaring. Noodzakelijke cookies zijn altijd actief.
					</p>
				</div>
				<div className="flex flex-col items-center w-full gap-2 sm:flex-row md:w-auto mt-4 md:mt-0">
					<Button
						className="bg-orange text-white hover:bg-orange-hover w-full sm:w-auto"
						onClick={() => updateConsent('granted')}
					>
						Accepteren
					</Button>
					<button
						className="text-sm text-gray-muted underline hover:text-blue transition-colors"
						onClick={() => updateConsent('denied')}
					>
						Liever niet
					</button>
				</div>
			</div>
		</div>
	);
}
